import React, { Component } from 'react';
import ImageAPI from '../../../api/ImageAPI';
import uuid from 'uuid';
import ImageLightbox from '../../../components/helpers/ImageLightbox.jsx';
import FlatButton from 'material-ui/FlatButton';
import Chip from 'material-ui/Chip';

import './CreateChromatic.css';

const CANVAS_MIN_SIDE = 400;
import { getRandomInt } from '../../../helpers/number';
const allCharaters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
  'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
  'W', 'X', 'Y', 'Z', 'a', 'b',
  'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
  'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  '!', '"', '#', '$', '%', '&', "'", '(', ')', '*',
  '+', ',', '-', '.', '/', '{', '|', '}', '~', ':', ';', '<', '=', '>',
  '?', '@'];

function getTextWidth(text, fontStyle) {
  // re-use canvas object for better performance
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  var context = canvas.getContext("2d");
  context.font = fontStyle;
  var metrics = context.measureText(text);
  return metrics.width;
}

export default class Chromatic extends Component {

  constructor(props) {
    super(props);
    this.state = {
      letterImages: [],
      preview: undefined,
      previewUrl: undefined,
      currentFont: 'Arial',
      error: false,
      errorMessage: undefined,
      loading: false
    }
    this.saveFont = this.saveFont.bind(this);
    this.handleFontChange = this.handleFontChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.generateFont = this.generateFont.bind(this);
  }

  handleFontChange(font) {
    this.setState({ currentFont: font })
  }

  saveFont() {
    const {
      letterImages,
      previewUrl
    } = this.state;

    ImageAPI.saveFont(letterImages, previewUrl, (response) => {
      console.log(response);
    })
  }

  handleFileUpload(e) {
    e.preventDefault();

    const file = e.target.files[0];
    if (!file.name.match(/.(jpg|jpeg|png)$/i)) {
      alert('Only image files work for now (.jpg, .png) - sorry about that. Please try again.');
      return
    }

    var reader = new FileReader();

    reader.onload = function (evt) {
      this.setState({
        preview: evt.target.result
      });
    }.bind(this);
    reader.readAsDataURL(file);

    // save the preview file to Imgur and database as a log
    ImageAPI.uploadToImgur(file, (response) => {
      console.log(response);
      const imageUrl = response.data.link;
      this.setState({
        previewUrl: imageUrl
      });
      ImageAPI.saveToDb(imageUrl);
    });
  }

  generateFont() {
    const {
      preview,
      currentFont,
    } = this.state;

    // clear current state
    this.setState({
      error: false,
      errorMessage: undefined,
      letterImages: []
    });

    // start generator
    this.setState({
      loading: true,
    })

    if (!preview) {
      this.setState({
        error: true,
        errorMessage: 'Please choose an image!',
        loading: false,
      });
      return
    }

    var canvas = this.canvas;
    var ctx = canvas.getContext("2d");

    // get width and height of image
    // resize image to be 400px wide. Reject images that are smaller.
    // position each character on top of the image as a mask in a random location
    // the characters will be font size 60px
    // crop the canvas at the location of the image
    // save and upload the character image

    var img = document.createElement("img");
    img.onload = function(){
      const height = img.height;
      const width = img.width;

      // original image needs to be at least 400x400
      if (width < 400 || height < 400) {
        this.setState({
          error: true,
          errorMessage: 'Please choose an image that is at least 400px x 400px'
        });
        return
      }

      // we want the shortest side of the canvas to be at least 400px
      if (width > height) {
        canvas.height = CANVAS_MIN_SIDE;
        canvas.width = width * (CANVAS_MIN_SIDE / height);
      }
      else if (width < height) {
        canvas.width = CANVAS_MIN_SIDE;
        canvas.height = height * (CANVAS_MIN_SIDE / width);
      }
      else {
        canvas.width = CANVAS_MIN_SIDE;
        canvas.height = CANVAS_MIN_SIDE;
      }
      const fontSize = 300;
      const fontFamily = currentFont;
      const canvasFont =  "900 " + fontSize + "px " + fontFamily;
      ctx.font = canvasFont;

      for (let i = 0; i < allCharaters.length; i++) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.save();
        ctx.beginPath();

        const letterWidth = getTextWidth(allCharaters[i], canvasFont);
        const letterHeight = fontSize;

        let maxY = canvas.height - fontSize;
        if (fontSize > canvas.height) {
          maxY = 1;
        }
        const yPos = getRandomInt(0, maxY);

        // set maximum xPosition of the letter
        let maxInt = canvas.width - letterWidth;
        if (letterWidth > canvas.width) {
          maxInt = 11;
        }
        const xPos = getRandomInt(10, maxInt);

        ctx.textBaseline = "hanging";
        ctx.fillText(allCharaters[i], xPos, yPos);
        ctx.fill();
        ctx.beginPath();
        ctx.globalCompositeOperation="source-in";

        if (width > height) {
          ctx.drawImage(img, 0, 0, width * (CANVAS_MIN_SIDE / height), CANVAS_MIN_SIDE);
        }
        else if (width < height) {
          ctx.drawImage(img, 0, 0, CANVAS_MIN_SIDE, height * (CANVAS_MIN_SIDE / width));
        }
        else {
          ctx.drawImage(img, 0, 0);
        }

        var tempCanvas = document.createElement("canvas"),
        tCtx = tempCanvas.getContext("2d");
        tempCanvas.width = letterWidth;
        tempCanvas.height = letterHeight;

        tCtx.drawImage(canvas, xPos, yPos, letterWidth, letterHeight, 0, 0, letterWidth, letterHeight);
        var outputImg = tempCanvas.toDataURL('image/png');
        const letterObj = {
          letter: allCharaters[i],
          image: outputImg
        };

        this.setState({
          letterImages: this.state.letterImages.concat([letterObj])
        });

        ctx.restore();
      }
      this.setState({
        loading: false,
      });
    }.bind(this);
    img.crossOrigin="anonymous";
    img.src = preview;
  }

  render () {
    const {
      letterImages,
      preview,
      error,
      errorMessage,
      loading
    } = this.state;

    const safeFonts = [
      'Arial',
      'Arial Narrow',
      'Arial Black',
      'Bookman',
      'Brush Script MT',
      'Century Gothic',
      'Comic Sans MS',
      'Copperplate',
      'Courier',
      'Courier New',
      'Futura',
      'Garamond',
      'Georgia',
      'Gill Sans',
      'Goudy Old Style',
      'Helvetica',
      'Impact',
      'Lucida Bright',
      'Lucida Sans Typewriter',
      'Palatino',
      'Papyrus',
      'Tahoma',
      'Times',
      'Times New Roman',
      'Trebuchet MS',
      'Verdana',
    ];

    return (
      <div>
        <div className="shadows-main-text">
          <div className="create-chromatic-header">
            <div className="chromatic-header-text">
              Create your own font
            </div>
            <div className="shadows-subheader-text">
              <p>
                Step 1: Upload an image
              </p>
              <FlatButton
                label="Choose an image"
                className="chromatic-upload-image"
                backgroundColor="#30353a"
                hoverColor="#686C6F"
                containerElement="label"
              >
                <input
                  type="file"
                  className="chromatic-upload-file-input"
                  onChange={this.handleFileUpload} />
              </FlatButton>
              <div className="chromatic-preview-image-container">
                {preview
                  ? <ImageLightbox src={preview} className="chromatic-preview-image" />
                  : null}
              </div>
              <p>
                Step 2: Choose a font
              </p>
              <div className="chromatic-font-styles-container">
                {safeFonts.map((font) => {
                  let chipClass = 'chromatic-font-styles-chip';
                  let labelColor = '#333';
                  const chipStyle =  {
                    fontFamily: font
                  }
                  if (font === this.state.currentFont) {
                    chipClass = 'chromatic-font-styles-chip-selected';
                    labelColor = '#fff';
                  }
                  return (
                    <Chip key={uuid.v4()}
                      className={chipClass}
                      style={chipStyle}
                      labelColor={labelColor}
                      onTouchTap={() => this.handleFontChange(font)}>
                      {font}
                    </Chip>
                  )
                })}
              </div>
              <p>
                Step 3: Have fun!
              </p>
              {loading
                ? <FlatButton
                  label="Loading ... just a moment ..."
                  className="chromatic-upload-image"
                  backgroundColor="#2979FF"
                  hoverColor="#448AFF"
                  disabled={true}
                />
                : <FlatButton
                  label="Generate my chromatic font!"
                  className="chromatic-upload-image"
                  backgroundColor="#2979FF"
                  hoverColor="#448AFF"
                  onClick={this.generateFont}
                />}

              {error ?
                <div className="chromatic-error-message">{errorMessage}</div>
                : null}
            </div>
            <div className="chromatic-content-container"
                ref={(input) => {this.canvasContainer = input}}>
              <div className="chromatic-canvas-container">
                  <canvas className="chromatic-canvas"
                    ref={(input) => {this.canvas = input }}
                    width={CANVAS_MIN_SIDE}
                    height={CANVAS_MIN_SIDE}></canvas>
              </div>
            </div>
            <div className="chromatic-letter-images-container">
              {letterImages.map((letterObj) => {
                return <img key={uuid.v4()}
                  alt={letterObj.letter}
                  src={letterObj.image}
                  className="chromatic-letter-image" />
              })}
            </div>
            <div className="chromatic-save-to-db">
              <FlatButton
                label="Save this font to the db"
                className="chromatic-upload-image"
                backgroundColor="#2979FF"
                hoverColor="#448AFF"
                onClick={this.saveFont}
              />
            </div>
          </div>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/chromatic/CreateChromatic.jsx